<template>
  <main class="container my-2" style="max-width: 1000px">

    <SimuladorStep v-if="!loading" :step="1" :valor="plano.valorMensal"
      :periodicidade="plano.modeloCobranca.periodicidade">
    </SimuladorStep>

    <div v-if="!loading" class="container-plano">
      <div class="row">
        <div class="col">
          <div class=" mt-2 text-center">
            <h5 class="simulador-titulo">Conheça os benefícios do seu plano </h5>
            <br />
            <p class="simulador-subtitulo">Aproveite!!</p>
          </div>
        </div>
      </div>

      <div class="row">

        <div class="col mt-2 d-flex justify-content-center" v-for="(produto, index) in plano.produtos" :key="index">

          <div class="row card-item m-1 mt-2" :style="{ 'background': !produto.selecionado ? '#fff' : '#f4fbfe' }">
            <div class="col">
              <div class="row text-center">
                <div class="col">
                  <strong>{{ produto.nome }}</strong>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-3 col-sm-3 col-md-2" style="display: block; margin-left: auto; margin-right: auto ">
                  <img :src="produto.icone" class="icon" alt="" style="height: 50px;">
                </div>
                <div class="col">


                  <div class="mt-5" v-if="produto.tipo == 'SEGURO' || produto.tipo == 'ASSISTENCIA_FUNERAL'">

                    <div class="range-slider"
                      :style="{ '--min': produto.valorMin, '--max': produto.valorMax, '--step': produto.valorStep, '--value': produto.valorSelecionado, '--text-value': formatPriceText(produto.valor) }">
                      <input type="range" :min="produto.valorMin" :max="produto.valorMax" :step="produto.valorStep"
                        v-model="produto.valorSelecionado" :disabled="!produto.selecionado"
                        @change="calcularValorParcela(produto)" @input="setValor(produto)">
                      <output></output>
                      <div class="range-slider__progress"></div>
                      <div class="row range-slider__steps">
                        <span class="col" v-for="(step, index) in produto.stepValores" :key="index">
                          <smal>R$ {{ formatPrice(step) }}</smal>
                        </span>
                      </div>
                    </div>

                  </div>
                  <div class="mt-2" v-else v-html="produto.descricaoCurta"></div>
                </div>
              </div>

              <div class="row mt-3">
                <button type="button" class="btn btn-link" @click="openDesc(produto.id)">
                  <span class="cor-principal ml-2"><strong><small>Saiba mais</small></strong></span>
                </button>

              </div>

              <div v-if="idProdutoDescOpen == produto.id" class="row mt-2 card-descricao">
                <div v-html="produto.descricao"></div>
              </div>

            </div>
          </div>
        </div>
        <div class="row">
          <div class="card-item assinar-plano card-fixed-top">

            <div class="text-center">

              <div style="font-weight: bold;display: flex;align-items: center;">
                <span class="m-2"> R$</span>
                <span style="font-size: 4rem;line-height: 4rem;">{{
                  formatPriceInteger(plano.valorMensal)
                }}</span>
                <span style="align-self: flex-start;">{{
                  formatPriceCents(plano.valorMensal)
                }}</span>
                <span class="m-2">
                  {{
                    formatPeriodicidade(
                      plano.modeloCobranca && plano.modeloCobranca.periodicidade
                        ? plano.modeloCobranca.periodicidade
                        : ""
                    )
                  }}
                </span>
              </div>
            </div>
            <div class="text-center">

              <button class="btn btn-aderir-plano" @click="continuar()">
                Assine agora
              </button>

            </div>
          </div>
        </div>
      </div>
    </div>

    <Loading v-if="loading"></Loading>

    <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              <strong>
                <span v-if="produtoOpen.tipo == 'CLUBE_DESCONTO' && produtoOpen.selecionado">
                  Adicionado cobertura Clube de
                  Vantagens
                </span>
                <span v-if="produtoOpen.tipo == 'SEGURO' && produtoOpen.selecionado">
                  Adicionado seguro de vida
                </span>

                <span v-if="produtoOpen.tipo == 'SEGURO' && !produtoOpen.selecionado">
                  Seguro de vida
                </span>
              </strong>
            </h5>
            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <span v-if="produtoOpen.tipo == 'CLUBE_DESCONTO' && produtoOpen.selecionado">
              O produto {{ produto.nome }} é pré-requisito, com isso esta opção não pode ser
              desmarcada.
            </span>
            <span v-if="produtoOpen.tipo == 'SEGURO' && produtoOpen.selecionado">
              Foi adicionado o seguro de vida porque é pré-requisito para Assistência Funeral Familiar, com isso esta
              opção não pode ser desmarcada.
            </span>
            <span v-if="produtoOpen.tipo == 'SEGURO' && !produtoOpen.selecionado">
              O seguro de vida é pré-requisito para Assistência Funeral Familiar, com isso esta
              opção não pode ser marcado.
            </span>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div  v-if="infoAtend || infoCondGerais " class="px-4 py-3 mb-4 mt-1 shadow" >
      <div v-if="infoAtend" v-html="infoAtend"></div>
      <div v-if="infoCondGerais" v-html="infoCondGerais"></div>
    </div>

  </main>
</template>
<script>
import Loading from "@/components/Loading.vue";
import { APIService } from "../../APIService";
import { SimuladorService } from "../../service/assinatura/SimuladorService";
import SimuladorStep from "@/components/assinaturas/SimuladorStep.vue";

const apiService = new APIService();
const simuladorService = new SimuladorService();

export default {
  name: "Simulador",
  props: [],
  components: { Loading, SimuladorStep },
  data() {
    return {
      profissoes: [],
      cliente: {
        profissao: "",
        idade: 14,
        sexo: "",
      },
      planoId: this.$route.params.idPlano,
      loading: true,
      checkout: false,
      produtoOpen: {
        nome: "",
        descricao: "",
      },
      plano: {
        produtos: []
      },
      logo: window.LOGO_RODAPE || "",
      valueInput: 0,
      idProdutoDescOpen: 0,
      funcionalidades: null,
      infoAtend: null,
      infoCondGerais: null,
    };
  },
  mounted() {
    this.obterFuncionalidades();
  },
  created() {

    this.$store.dispatch("toogleFooter", 0);

    this.plano = this.obterPlanoSimulacao();
    this.obterListaOcupacao();

  },
  methods: {
    atualizarValor(produto, valor) {
      if (produto.selecionado) {
        if ((produto.valorMin <= produto.valor && produto.valorMax > produto.valor || valor < 0)) {
          produto.valor = produto.valor == 0 && valor < 0 ? 0 : produto.valor + valor;
          this.recalcular();
        }
      }
    },
    openDesc(idProdutoDescOpen) {

      if (this.idProdutoDescOpen == idProdutoDescOpen) {
        this.idProdutoDescOpen = 0;
      } else {
        this.idProdutoDescOpen = idProdutoDescOpen;
      }

    },
    obterListaOcupacao() {
      apiService
        .obterListaOcupacao()
        .then((res) => {
          this.profissoes = res;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    inputRange(produto) {
      this.setValor(produto);
      var value = (100 / (parseInt(produto.valorMax) - parseInt(produto.valorMin))) * parseInt(produto.valorSelecionado) - (100 / (parseInt(produto.valorMax) - parseInt(produto.valorMin))) * parseInt(produto.valorMin);
      if (value < 0) {
        value = 0
      }
      produto.inputRange.thumb = value;
      produto.inputRange.sign = value;
    },
    setValor(produto) {
      if (produto.stepValores) {
        for (let i = 0; i < produto.stepValores.length; i++) {
          let valor = produto.stepValores[i];
          if (produto.valorSelecionado >= (valor - produto.valorStep) && produto.valorSelecionado <= (valor + produto.valorStep)) {
            produto.valor = valor;
          }
        }
      } else {
        produto.valor = produto.valorSelecionado;
      }
    },

    calcularValorTitular(produto) {
      return simuladorService.calcularValorTitular(produto);
    },
    calcularValorDependente(produto) {
      return simuladorService.calcularValorDependente(produto);
    },
    podeSelecionar(produto) {
      let podeSelecionar = true;

      if (produto.soTitular) {
        podeSelecionar = false;
      } else if (produto.idVinculoObrigatorio) {
        for (let x = 0; x < this.plano.produtos.length; x++) {
          let produtoVinculo = this.plano.produtos[x];

          if (produto.idVinculoObrigatorio == produtoVinculo.id) {
            if (produtoVinculo.selecionado) {
              podeSelecionar = true;
            } else {
              podeSelecionar = false;
            }
          }
        }
      }
      return podeSelecionar;
    },
    mapCamposDeControle() {
      for (let x = 0; x < this.plano.produtos.length; x++) {
        let produto = this.plano.produtos[x];
        produto.soTitular = false;
        produto.inputRange = { rangeRight: 0, rangeLeft: 0, thumb: 0, sign: 0 };

      }
    },
    formatPeriodicidade(periodicidade) {
      return simuladorService.formatPeriodicidade(periodicidade);
    },
    recalcular() {
      simuladorService.calcularValorParcelas(this.plano);
    },
    changeProdutoOpen(produtoOpen) {
      this.produtoOpen = produtoOpen;
    },
    obterPlanoSimulacao() {
      this.loading = true;
      if (this.$store.state.simulacaoPlano) {
        this.plano = this.$store.state.simulacaoPlano;
        this.recalcular();
        this.loading = false;
      } else {
        apiService
          .obterPlanoSimulacao(this.planoId)
          .then((res) => {
            this.plano = res;
            this.mapCamposDeControle();
            this.recalcular();
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            console.log(error);
          });
      }
    },
    formatPrice(value) {
      let val = ((value || 0) / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatPriceText(value) {
      let val = ((value || 0) / 1).toFixed(2).replace(".", ",");
      let valor = '"R$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + '"';

      return valor;
    },
    formatPriceInteger(value) {
      let val = ((value || 0) / 1).toFixed(2).replace(".", ",");
      return val
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        .replace(/.{3}$/g, "");
    },
    formatPriceCents(value) {
      let val = ((value || 0) / 1).toFixed(2).replace(".", ",");
      return val
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        .replace(/^[\d.]+/g, "");
    },
    selecionarServico(produto) {
      simuladorService.calcularValorParcela(this.plano, produto);
    },
    calcularValorParcela(produto) {
      produto.selecionado = true;
      simuladorService.calcularValorParcela(this.plano, produto);
    },
    calcularValorParcelas() {
      simuladorService.calcularValorParcelas(this.plano);
    },
    calcularValorMensal() {
      simuladorService.calcularValorMensal(this.plano);
    },
    continuar() {
      localStorage.removeItem("dados-cadastro");
      localStorage.setItem("simulacao-plano", JSON.stringify(this.plano));
      this.$router.push(`/planos/simulador-step-2`);
    },
    obterFuncionalidades() {
      this.loading = true;
      apiService
        .getFuncionalidadeV2(window.APP_ORIGIN)
        .then((res) => {
         const funcionalidades =
            res.filter((e) => {
              return "MICROAPP_TEXTOS" == e.funcionalidade;
            });

          const valorString = funcionalidades[0].valorString;
          this.funcionalidades = JSON.parse(valorString);

          const atendInfo = this.funcionalidades.find(objeto => objeto.codigoMicroapp === "MAPP_INFO_ATEND");
          if (atendInfo && atendInfo.ativo) {
            const currentRoute = this.$route.path;
              let rotaCorresponde = false;
              for (const pagina of atendInfo.paginas) {
                  if (currentRoute.includes(pagina)) {
                      rotaCorresponde = true;
                      break;
                  }
              }

              if (rotaCorresponde) {
                this.infoAtend = atendInfo.html;
              }
          }

          const condGerais = this.funcionalidades.find(objeto => objeto.codigoMicroapp === "MAPP_COND_GERAIS");
          if (condGerais && condGerais.ativo) {
            const currentRoute = this.$route.path;
              let rotaCorresponde = false;
              for (const pagina of condGerais.paginas) {
                  if (currentRoute.includes(pagina)) {
                      rotaCorresponde = true;
                      break;
                  }
              }

              if (rotaCorresponde) {
                this.infoCondGerais = condGerais.html;
              }
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log("log error", error);
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss">
.container-plano {
  flex-direction: column;
  margin-left: 0px;
}

.assinar-plano {
  position: fixed;
  bottom: 0;
  margin: 0 !important;
  left: 0;
  min-width: 100% !important;
  flex-direction: row !important;
  justify-content: space-around !important;
  max-height: 100px !important;
  max-width: 300px !important;
  flex-direction: column;
  display: flex;
}


.nome-produto {
  color: #000;
  font-size: 1.5rem;
  margin: 0 8px;
  width: 50%;
}


.icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  max-width: 38%;
  font-size: 120%;
  transition: 0.5s;
  color: var(--cor-secundaria);
  overflow: hidden;
}

.simulador-titulo {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  color: var(--cor-principal);
}

.simulador-subtitulo {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
}


.custom-range {
  -webkit-appearance: none;
  width: 100%;
  height: 20px;
  border-radius: 34px;
  background: linear-gradient(180deg, #e2e2e2 0%, rgba(244, 244, 244, 0) 100%);
  border: 1px solid #dcd1d1;
  outline: none;
  opacity: 0.7;
  -webkit-transition: .2s;
  transition: opacity .2s;
  border-radius: 15px;
}

.custom-range:hover {
  opacity: 1;
}

.custom-range::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  background: var(--cor-principal);
  cursor: pointer;
  border-radius: 15px;
}

.custom-range::-moz-range-thumb {
  width: 25px;
  height: 25px;
  background: var(--cor-principal);
  cursor: pointer;
}

.align-item {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.v-line {
  border-right: 1px solid;
  border-left: 1px solid;
}

.cor-principal {
  color: var(--cor-principal);
}

.cobertura {
  color: var(--cor-principal);
  font-size: 14px;
  font-weight: bold;
}

.valor-contribuicao {
  color: var(--cor-principal);
  font-size: 14px;
  font-weight: bold;
}

.card-item {

  border: 0px solid;
  max-width: 1000px;
  width: 9400px;
  align-content: center;
  border: 1px solid #ececec;
  background: #fff;
  box-shadow: 0px 50px 70px -20px rgba(4, 130, 170, 0.15);
  border-radius: 5px;
  padding: 15px;
}

.card-descricao {

  border: 0px solid;
  align-content: center;
  border: 1px solid #ececec;
  background: #fff;
  box-shadow: 0px 50px 70px -20px rgba(4, 130, 170, 0.15);
  border-radius: 15px;
  padding: 16px;

}



/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 25px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 25px;
  width: 25px;
  left: 0px;
  bottom: -1px;
  background-color: #606062;
  transition: 0.4s;
}

input:checked+.slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
  background: var(--cor-principal);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
  background: linear-gradient(180deg, #e2e2e2 0%, rgba(244, 244, 244, 0) 100%);
  border: 1px solid #dcd1d1;
}

.slider.round:before {
  border-radius: 50%;
}

// .slider.round::before {



.btn-sexo {
  background: #0f95bf;
  border-radius: 30px;
  font-weight: 600;
  font-size: 18px;
}



.range-slider {
  --primary-color: #0f95bf;
  --value-disable-color: #606062;
  --value-offset-y: var(--ticks-gap);
  --value-active-color: white;
  --value-background: transparent;
  --value-background-hover: var(--primary-color);
  --value-font: 700 12px/1 Arial;

  --fill-color: var(--primary-color);
  --progress-background: #eee;
  --progress-radius: 20px;
  --track-height: calc(var(--thumb-size) / 2);

  --min-max-font: 12px Arial;
  --min-max-opacity: 0.5;
  --min-max-x-offset: 10%; // 50% to center

  --thumb-size: 22px;
  --thumb-color: white;
  --thumb-shadow: 0 0 3px rgba(0, 0, 0, 0.4), 0 0 1px rgba(0, 0, 0, 0.5) inset,
    0 0 0 99px var(--thumb-color) inset;

  --thumb-shadow-active: 0 0 0 calc(var(--thumb-size) / 4) inset var(--thumb-color),
    0 0 0 99px var(--primary-color) inset, 0 0 3px rgba(0, 0, 0, 0.4);

  --thumb-shadow-hover: var(--thumb-shadow);

  --ticks-thickness: 1px;
  --ticks-height: 5px;
  --ticks-gap: var(--ticks-height,
      0); // vertical space between the ticks and the progress bar
  --ticks-color: silver;

  // ⚠️ BELOW VARIABLES SHOULD NOT BE CHANGED
  --step: 1;
  --ticks-count: Calc(var(--max) - var(--min)) / var(--step);
  --maxTicksAllowed: 56;
  --too-many-ticks: Min(1, Max(var(--ticks-count) - var(--maxTicksAllowed), 0));
  --x-step: Max(var(--step),
      var(--too-many-ticks) * (var(--max) - var(--min))); // manipulate the number of steps if too many ticks exist, so there would only be 2
  --tickInterval: 100/ ((var(--max) - var(--min)) / var(--step)) * var(--tickEvery, 1);
  --tickIntervalPerc: calc((100% - var(--thumb-size)) / ((var(--max) - var(--min)) / var(--x-step)) * var(--tickEvery, 1));

  --value-a: Clamp(var(--min),
      var(--value, 0),
      var(--max)); // default value ("--value" is used in single-range markup)
  --value-b: var(--value, 0); // default value
  --text-value-a: var(--text-value, "");

  --completed-a: calc((var(--value-a) - var(--min)) / (var(--max) - var(--min)) * 100);
  --completed-b: calc((var(--value-b) - var(--min)) / (var(--max) - var(--min)) * 100);
  --ca: Min(var(--completed-a), var(--completed-b));
  --cb: Max(var(--completed-a), var(--completed-b));

  // breakdown of the below super-complex brain-breaking CSS math:
  // "clamp" is used to ensure either "-1" or "1"
  // "calc" is used to inflat the outcome into a huge number, to get rid of any value between -1 & 1
  // if absolute diff of both completed % is above "5" (%)
  // ".001" bumps the value just a bit, to avoid a scenario where calc resulted in "0" (then clamp will also be "0")
  --thumbs-too-close: Clamp(-1,
      1000 * (Min(1, Max(var(--cb) - var(--ca) - 5, -1)) + 0.001),
      1);
  --thumb-close-to-min: Min(1, Max(var(--ca) - 2, 0)); // 2% threshold
  --thumb-close-to-max: Min(1, Max(98 - var(--cb), 0)); // 2% threshold

  @mixin thumb {
    appearance: none;
    height: var(--thumb-size);
    width: var(--thumb-size);
    transform: var(--thumb-transform);
    border-radius: var(--thumb-radius, 50%);
    background: var(--thumb-color);
    box-shadow: var(--thumb-shadow);
    border: none;
    pointer-events: auto;
    transition: 0.1s;
  }

  display: inline-block;
  height: Max(var(--track-height), var(--thumb-size));
  // margin: calc((var(--thumb-size) - var(--track-height)) * -.25) var(--thumb-size) 0;
  background: linear-gradient(to right,
    var(--ticks-color) var(--ticks-thickness),
    transparent 1px) repeat-x;
  background-size: var(--tickIntervalPerc) var(--ticks-height);
  background-position-x: calc(var(--thumb-size) / 2 - var(--ticks-thickness) / 2);
  background-position-y: var(--flip-y, bottom);

  padding-bottom: var(--flip-y, var(--ticks-gap));
  padding-top: calc(var(--flip-y) * var(--ticks-gap));

  position: relative;
  z-index: 1;

  &[data-ticks-position="top"] {
    --flip-y: 1;
  }

  // // mix/max texts
  // &::before,
  // &::after {
  //   --offset: calc(var(--thumb-size) / 2);
  //   content: counter(x);
  //   display: var(--show-min-max, block);
  //   font: var(--min-max-font);
  //   position: absolute;
  //   bottom: var(--flip-y, -2.5ch);
  //   top: calc(-2.5ch * var(--flip-y));
  //   opacity: Clamp(0, var(--at-edge), var(--min-max-opacity));
  //   transform: translateX(calc(var(--min-max-x-offset) * var(--before, -1) * -1)) scale(var(--at-edge));
  //   pointer-events: none;
  // }

  &::before {
    --before: 1;
    --at-edge: var(--thumb-close-to-min);
    counter-reset: x var(--min);
    left: var(--offset);
  }

  &::after {
    --at-edge: var(--thumb-close-to-max);
    counter-reset: x var(--max);
    right: var(--offset);
  }

  &__values {
    position: relative;
    top: 50%;
    line-height: 0;
    text-align: justify;
    width: 100%;
    pointer-events: none;
    margin: 0 auto;
    z-index: 5;

    // trick so "justify" will work
    &::after {
      content: "";
      width: 100%;
      display: inline-block;
      height: 0;
      background: red;
    }
  }

  &__steps {
    margin-top: 20px;
    color: var(--primary-color);
  }

  &__progress {
    --start-end: calc(var(--thumb-size) / 2);
    --clip-end: calc(100% - (var(--cb)) * 1%);
    --clip-start: calc(var(--ca) * 1%);
    --clip: inset(-20px var(--clip-end) -20px var(--clip-start));
    position: absolute;
    left: var(--start-end);
    right: var(--start-end);
    top: calc(var(--ticks-gap) * var(--flip-y, 0) + var(--thumb-size) / 2 - var(--track-height) / 2);
    //  transform: var(--flip-y, translateY(-50%) translateZ(0));
    height: calc(var(--track-height));
    background: var(--progress-background, #eee);
    pointer-events: none;
    z-index: -1;
    border-radius: var(--progress-radius);

    // fill area
    &::before {
      content: "";
      position: absolute;
      // left: Clamp(0%, calc(var(--ca) * 1%), 100%); // confine to 0 or above
      // width: Min(100%, calc((var(--cb) - var(--ca)) * 1%)); // confine to maximum 100%
      left: 0;
      right: 0;
      clip-path: var(--clip);
      top: 0;
      bottom: 0;
      background: var(--fill-color, black);
      box-shadow: var(--progress-flll-shadow);
      z-index: 1;
      border-radius: inherit;
    }

    // shadow-effect
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      box-shadow: var(--progress-shadow);
      pointer-events: none;
      border-radius: inherit;
    }
  }

  &>input {
    -webkit-appearance: none;
    width: 100%;
    height: var(--thumb-size);
    margin: 0;
    position: absolute;
    left: 0;
    top: calc(50% - Max(var(--track-height), var(--thumb-size)) / 2 + calc(var(--ticks-gap) / 2 * var(--flip-y, -1)));
    cursor: -webkit-grab;
    cursor: grab;
    outline: none;
    background: none;

    &:not(:only-of-type) {
      pointer-events: none;
    }

    &::-webkit-slider-thumb {
      @include thumb;
    }

    &::-moz-range-thumb {
      @include thumb;
    }

    &::-ms-thumb {
      @include thumb;
    }

    &:hover {
      --thumb-shadow: var(--thumb-shadow-hover);

      &+output {
        --value-background: var(--value-background-hover);
        --y-offset: -5px;
        color: var(--value-active-color);
        box-shadow: 0 0 0 3px var(--value-background);
      }
    }

    & {
      --thumb-shadow: var(--thumb-shadow-hover);

      &+output {
        --value-background: var(--value-disable-color);
        --y-offset: -5px;
        color: var(--value-active-color);
        box-shadow: 0 0 0 3px var(--value-background);
      }


    }


    &:active {
      --thumb-shadow: var(--thumb-shadow-active);
      cursor: grabbing;
      z-index: 2; // when sliding left thumb over the right or vice-versa, make sure the moved thumb is on top

      +output {
        transition: 0s;
      }
    }

    &:nth-of-type(1) {
      --is-left-most: Clamp(0, (var(--value-a) - var(--value-b)) * 99999, 1);

      &+output {
        &:not(:only-of-type) {
          --flip: calc(var(--thumbs-too-close) * -1);
        }

        --value: var(--value-a);
        --x-offset: calc(var(--completed-a) * -1%);

        &::after {
          content: var(--prefix, "") var(--text-value-a) var(--suffix, "");
        }
      }
    }

    &:nth-of-type(2) {
      --is-left-most: Clamp(0, (var(--value-b) - var(--value-a)) * 99999, 1);

      &+output {
        --value: var(--value-b);
      }
    }

    // non-multiple range should not clip start of progress bar
    &:only-of-type {
      ~.range-slider__progress {
        --clip-start: 0;
      }
    }

    &+output {
      --flip: -1;
      --x-offset: calc(var(--completed-b) * -1%);
      --pos: calc(((var(--value) - var(--min)) / (var(--max) - var(--min))) * 100%);

      pointer-events: none;
      position: absolute;
      z-index: 5;
      background: var(--value-background);
      border-radius: 10px;
      padding: 2px 4px;
      left: var(--pos);
      transform: translate(var(--x-offset),
          calc(150% * var(--flip) - (var(--y-offset, 0px) + var(--value-offset-y)) * var(--flip)));
      transition: all 0.12s ease-out, left 0s;

      &::after {
        content: var(--prefix, "") var(--text-value-b) var(--suffix, "");
        font: var(--value-font);
      }
    }
  }
}

.range-slider,
label[dir="rtl"] .range-slider {
  width: 100%;
  min-width: 200px;
}


@media (max-width: 575.98px) {
  .icon {
    max-width: 95%;

  }
}
</style>
